export default "__VITE_ASSET__CVdQez2r__"